import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';

import { AdjustedPaymentTermSimulationModalAb } from './adjustedPaymentTermSimulation.ab';
import { AdjustedPaymentTermSimulationModalBCP } from './adjustedPaymentTermSimulation.bcp';

export const AdjustedPaymentTermSimulationModal = () => {
	return (
		<RenderComponent
			components={{
				ab: {
					desktop: <AdjustedPaymentTermSimulationModalAb />,
					mobile: <AdjustedPaymentTermSimulationModalAb />,
					intranet: null,
				},
				bcp: {
					desktop: <AdjustedPaymentTermSimulationModalBCP />,
					mobile: <AdjustedPaymentTermSimulationModalBCP />,
					intranet: null,
				},
			}}
		/>
	);
};
